/**
 * Labstep
 */

import { useModalWizardContext } from 'labstep-web/contexts/modal-wizard/hook';
import { Flex } from 'labstep-web/core/Flex';
import { Header } from 'labstep-web/core/Header';
import { ModalWizardActions } from 'labstep-web/core/Modal/Wizard/Actions';
import { ModalWizardStepHelp } from 'labstep-web/core/Modal/Wizard/Step/Help';
import React from 'react';
import { Modal } from 'semantic-ui-react';
import styles from './styles.module.scss';
import type { IModalWizardStepProps } from './types';

export const ModalWizardStep: RFC<IModalWizardStepProps> = ({
  index,
  description,
  children,
  help,
  hideBackButton,
  hideContinueButton,
  isContinueButtonDisabled,
  continueLabel,
  continueText,
  onContinue,
  onBack,
  actions,
  hideHeader,
}) => {
  const { activeStepIndex, steps } = useModalWizardContext();
  if (activeStepIndex !== index) {
    return null;
  }
  return (
    <>
      <Modal.Content className={styles.container}>
        <Flex column className={styles.content}>
          {!(hideHeader && !description) && (
            <div>
              {!hideHeader && (
                <Header>{steps[activeStepIndex]}</Header>
              )}
              {description && (
                <div className={styles.description}>
                  {description}
                </div>
              )}
            </div>
          )}
          <Flex grow>{children as any}</Flex>
        </Flex>
        {help && <ModalWizardStepHelp help={help} />}
      </Modal.Content>
      <ModalWizardActions
        onContinue={onContinue}
        onBack={onBack}
        hideBackButton={hideBackButton}
        hideContinueButton={hideContinueButton}
        isContinueButtonDisabled={isContinueButtonDisabled}
        continueLabel={continueLabel}
        continueText={continueText}
        actions={actions}
      />
    </>
  );
};
